import { BaseRemoteService } from "@ofqual/portal-core/core/dataAccess";
import {
  Model,
  PagedResponse,
  QueryParams,
} from "@ofqual/portal-core/core/types";
import {
  UnknownPagedResponse,
  toPagedResponse,
} from "@ofqual/portal-core/core/types/LegacyPagedResponse";
import { paramsToSearchString } from "@ofqual/portal-core/core/utils/urlHelper";
import { useSelector } from "react-redux";
import { LinkedRecordType } from "..";
import { LinkedRecordTypeDefinition } from "../domain/LinkedRecordTypeDefinition";
import { authSelector, linkedRecordsSelector } from "../redux/selectors";

export const useLookupService = (
  definition: LinkedRecordTypeDefinition,
  entityReferenceId: string
) => {
  const { token } = useSelector(authSelector);
  const linkedRecordState = useSelector(linkedRecordsSelector);
  const linkedRecordEntityState = linkedRecordState[entityReferenceId];

  return {
    search: (params: QueryParams = {}) => {
      const mappedParams = definition.searchParamMapper
        ? definition.searchParamMapper(params)
        : params;

      const url =
        definition.searchUrlRoot + paramsToSearchString(mappedParams, "&");

      return BaseRemoteService.fetch<PagedResponse<Model>>(
        url,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
        async (apiResponse) => {
          const response = ((await apiResponse.json()) as unknown) as UnknownPagedResponse<Model>;
          const pagedResponse = toPagedResponse(response);
          const filteredResponse = pagedResponse;

          for (var x = 0; x < pagedResponse.data.length; x++) {
            for (
              var i = 0;
              i < linkedRecordEntityState.response.data.length;
              i++
            ) {
              switch (definition.type) {
                case LinkedRecordType.organisation:
                  if (
                    parseInt(pagedResponse.data[x].itemId) ===
                      parseInt(
                        linkedRecordEntityState.response.data[i].destinationId
                      ) ||
                    pagedResponse.data[x].id ===
                      linkedRecordEntityState.response.data[i].sourceId
                  ) {
                    filteredResponse.data[x].disabled = true;
                  }
                  break;
                case LinkedRecordType.user:
                  if (
                    pagedResponse.data[x].loginEmail ===
                      linkedRecordEntityState.response.data[i].destinationId ||
                    pagedResponse.data[x].id ===
                      linkedRecordEntityState.response.data[i].sourceId
                  ) {
                    filteredResponse.data[x].disabled = true;
                  }
                  break;
                default:
                  if (
                    pagedResponse.data[x].id ===
                      linkedRecordEntityState.response.data[i].destinationId ||
                    pagedResponse.data[x].id ===
                      linkedRecordEntityState.response.data[i].sourceId
                  ) {
                    filteredResponse.data[x].disabled = true;
                  }
              }
            }
          }

          const returnResponse = {
            ...filteredResponse,
            data: filteredResponse.data.map((item) =>
              definition.searchResponseMapper
                ? definition.searchResponseMapper(item)
                : item
            ),
          };
          return returnResponse;
        }
      );
    },
  };
};
